<template>
    <div class="px-1 pb-1">
        <div v-if="garageSalary" class="alert alert-primary">
            <div class="alert-body">
                Personelin çalıştığı garaj için önerilen maaş <b>{{garageSalary}} TL</b>'dir.
            </div>
        </div>
        <div class="row">
            <div class="col-md-6" v-if="gStatus">
                <div class="alert alert-dark mb-0 border">
                    <div class="alert-body p-75">
                        <div class="row">
                            <div class="col-12 mb-1">
                                <!-- <label class="form-label">Maaş ({{value.net.IsMinimumWage ? 'Brüt' : 'Net'}})</label> -->
                                <label class="form-label">Tutar</label>
                                <v-validator :errors="errors" parameter="EmployeeSalary.NetSalary" :watch="value.net.Salary">
                                    <v-currency-input input-class="text-right" :value="value.net.Salary" v-on:update-value="v => value.net.Salary = v"></v-currency-input>
                                    <div class="row mt-1">
                                        <b-form-checkbox class="ml-50 col-auto" v-model="value.net.IsMinimumWage">Asgari Ücret</b-form-checkbox>
                                        <b-form-checkbox disabled class="ml-50 col-auto" v-model="!value.net.IsMinimumWage">Net</b-form-checkbox>
                                    </div>
                                </v-validator>
                            </div>
                            <div class="col-12 mb-1">
                                <label class="form-label">Maaş Para Birimi</label>
                                <v-validator :errors="errors" parameter="EmployeeSalary.NetSalaryCurrencyUnitId" :watch="netSalaryUnit">
                                    <v-select-list :options="currencies" placeholder="Maaş Para Birimi" v-model="netSalaryUnit" label="Name"></v-select-list>
                                </v-validator>
                            </div>
                            <div class="col-12 mb-1">
                                <label class="form-label">Maaş Tipi</label>
                                <v-validator :errors="errors" parameter="EmployeeSalary.NetSalaryTypeId" :watch="netSalaryType">
                                    <v-select-list :options="types" placeholder="Maaş Tipi" v-model="netSalaryType" label="Name"></v-select-list>
                                </v-validator>
                            </div>
                            <div class="col-12 mb-1">
                                <label class="form-label">Maaş Son Geçerlilik Tarihi('e kadar)</label>
                                <v-validator :errors="errors" parameter="EmployeeSalary.NetDate" :watch="value.net.Date">
                                    <v-date-picker v-model="value.net.Date" placeholder="Güncel Maaş Geçerlilik Tarihi"/>
                                </v-validator>
                            </div>
                            <div class="col-12 text-right">
                                <v-executer :loading="netLoading" text="Maaş Bilgilerini Güncelle" :action="saveNet"></v-executer>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div :class="gStatus ? 'col-md-6':'col-12'">
                <div class="alert mb-0 border">
                    <div class="alert-body p-75">
                        <div class="row">
                            <div class="col-12 mb-1">
                                <!-- <label class="form-label"><span v-if="gStatus">SGK</span> Maaş <span class="text-secondary font-weight-bolder">({{value.sgk.IsMinimumWage ? 'Brüt' : 'Net'}})</span></label> -->
                                <label class="form-label"><span v-if="gStatus">SGK Tutar</span></label>
                                <v-validator :errors="errors" parameter="EmployeeSalary.SGKSalary" :watch="value.sgk.Salary">
                                    <v-currency-input input-class="text-right" :value="value.sgk.Salary" v-on:update-value="v => value.sgk.Salary = v"></v-currency-input>
                                    <div class="row mt-1">
                                        <b-form-checkbox class="ml-50 col-auto" v-model="value.sgk.IsMinimumWage">Asgari Ücret</b-form-checkbox>
                                        <b-form-checkbox disabled class="ml-50 col-auto" v-model="!value.sgk.IsMinimumWage">Net</b-form-checkbox>
                                    </div>
                                </v-validator>
                            </div>
                            <div class="col-12 mb-1">
                                <label class="form-label"><span v-if="gStatus">SGK</span> Maaş Para Birimi</label>
                                <v-validator :errors="errors" parameter="EmployeeSalary.SGKSalaryCurrencyUnitId" :watch="sgkSalaryUnit">
                                    <v-select-list :options="currencies" placeholder="SGK Maaş Para Birimi" v-model="sgkSalaryUnit" label="Name"></v-select-list>
                                </v-validator>
                            </div>
                            <div class="col-12 mb-1">
                                <label class="form-label"><span v-if="gStatus">SGK</span> Maaş Tipi</label>
                                <v-validator :errors="errors" parameter="EmployeeSalary.SGKSalaryTypeId" :watch="sgkSalaryType">
                                    <v-select-list :options="types" placeholder="SGK Maaş Tipi" v-model="sgkSalaryType" label="Name"></v-select-list>
                                </v-validator>
                            </div>
                            <div class="col-12 mb-1">
                                <label class="form-label"><span v-if="gStatus">SGK</span> Güncel Maaş Geçerlilik Tarihi('den itibaren)</label>
                                <v-validator :errors="errors" parameter="EmployeeSalary.SGKDate" :watch="value.sgk.Date">
                                    <v-date-picker v-model="value.sgk.Date" type="month" placeholder="SGK Güncel Maaş Geçerlilik Tarihi"/>
                                </v-validator>
                            </div>
                            <div class="col-12 text-right">
                                <v-executer :loading="sgkLoading" text="SGK Maaş Bilgilerini Güncelle" :action="saveSGK"></v-executer>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- <div class="col-12">
                <employee-salary-graph v-if="list.length" :datas="list"></employee-salary-graph>
            </div>
            <div class="col-12">
                <div class="table-responsive mt-1">
                    <table class="table table-sm table-bordered">
                        <thead>
                            <tr>
                                <th class="text-nowrap">Güncellenme</th>
                                <th v-if="gStatus" class="w-12 text-nowrap">Güncel Maaş Geçerlilik Tarihi</th>
                                <th v-if="gStatus" class="w-14 text-nowrap">Maaş</th>
                                <th v-if="gStatus" class="w-12 text-nowrap">Maaş Birimi</th>
                                <th v-if="gStatus" class="w-12 text-nowrap">Maaş Tipi</th>
                                <th class="text-nowrap" :class="gStatus ? 'w-12':'w-25'"><span v-if="gStatus">SGK</span> Güncel Maaş Geçerlilik Tarihi</th>
                                <th class="text-nowrap" :class="gStatus ? 'w-14':'w-25'"><span v-if="gStatus">SGK</span> Maaş</th>
                                <th class="text-nowrap" :class="gStatus ? 'w-12':'w-25'"><span v-if="gStatus">SGK</span> Maaş Birimi</th>
                                <th class="text-nowrap" :class="gStatus ? 'w-12':'w-25'"><span v-if="gStatus">SGK</span> Maaş Tipi</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(salary,index) in list" :key="'s'+index" :class="{'bg-light-secondary font-weight-bolder':index == 0}">
                                <td>{{$safe(salary,"CreateTime") || "-"}}</td>
                                <td v-if="gStatus">{{$safe(salary,"NetDate") || "-"}}</td>
                                <td v-if="gStatus">
                                    <div class="d-flex align-items-center justify-content-between">
                                        {{$safe(salary,"NetSalaryStr") || "-"}}
                                        <span v-if="index == 0" class="material-icons-round text-secondary">done</span>
                                    </div>
                                </td>
                                <td v-if="gStatus">{{$safe(salary,"NetSalaryCurrencyUnitName") || "-"}}</td>
                                <td v-if="gStatus">{{$safe(salary,"NetSalaryTypeName") || "-"}}</td>
                                <td>{{$safe(salary,"SGKDate") || "-"}}</td>
                                <td>
                                    <div class="d-flex align-items-center justify-content-between">
                                        {{$safe(salary,"SGKSalaryStr") || "-"}}
                                        <span v-if="index == 0" class="material-icons-round text-secondary">done</span>
                                    </div>
                                </td>
                                <td>{{$safe(salary,"SGKSalaryCurrencyUnitName") || "-"}}</td>
                                <td>{{$safe(salary,"SGKSalaryTypeName") || "-"}}</td>
                            </tr>
                            <tr>
                                <td class="text-center" v-if="list.length == 0" colspan="9">Heniz bir veri bulunmaktadır.</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <table></table>
            </div> -->
        </div>
        <!-- <div class="text-right">
            <v-executer :loading="loading" text="Maaş Bilgilerini Güncelle" :action="save"></v-executer>
        </div> -->
    </div>
</template>

<script>
import System from '@/utilities/system'
import SystemDataApi from '@/api/system-data'
import Additional from '@/utilities/additional'
import EmployeeOperationsApi from '@/api/employee-operations' 
import EmployeeSalaryGraph from './EmployeeSalaryGraph.vue'
import VCurrencyInput from '@/components/VCurrencyInput.vue'
import { BFormCheckbox } from 'bootstrap-vue'
import moment from 'moment'



export default {
    components:{
        EmployeeSalaryGraph,
        VCurrencyInput,
        BFormCheckbox
    },
    props:{
        id:[String,Number],
        value:Object,
        getPersonal:Function,
        garageSalary:{
            type:String,
            default:null
        },
        list:{
            type:Object,
            default:()=>({})
        }
    },
    data() {
        return {
            sgkLoading:false,
            netLoading:false,
            currencies:[],
            types:[],
            errors:{}
        }
    },
    mounted(){
        this.getCurrencyUnits()
        this.getSalaryTypes()
    },
    methods:{
        saveNet(){
            this.save(false)
        },
        saveSGK(){
            this.save(true)
        },
        async save(bool){
            let base = {
                Step:6,
                EmployeeId:this.id,
                EmployeeSGKSalary: bool ? {
                    EmployeeId:this.id,
                    Date:'0001-01-01',
                    Month:this.value.sgk.Date ? moment(this.value.sgk.Date,'YYYY-MM-DD').month() + 1 : null,
                    Year:this.value.sgk.Date ? moment(this.value.sgk.Date,'YYYY-MM-DD').year()  : null,
                    Salary: this.value.sgk.Salary,
                    CurrencyUnitId: this.value.sgk.CurrencyUnitId,
                    UCRET_NEVI:this.value.sgk.UCRET_NEVI,
                    SGK:true,
                    ASGARI_UCRETLI:this.value.sgk.IsMinimumWage
                } : null,
                EmployeeNetSalary:!bool ? {
                    EmployeeId:this.id,
                    Date:this.value.net.Date,
                    Month:null,
                    Year:null,
                    Salary: this.value.net.Salary,
                    CurrencyUnitId: this.value.net.CurrencyUnitId,
                    UCRET_NEVI:this.value.net.UCRET_NEVI,
                    SGK:false,
                    ASGARI_UCRETLI:this.value.net.IsMinimumWage
                } : null
            }
            const data = structuredClone(base)
            if(bool){
                if(data.EmployeeSGKSalary.Salary == null){
                    data.EmployeeSGKSalary.Salary = -1
                }else{
                    data.EmployeeSGKSalary.Salary = String(data.EmployeeSGKSalary.Salary).replace('.',',')
                }
            }else{
                if(data.EmployeeNetSalary.Salary == null){
                    data.EmployeeNetSalary.Salary = -1
                } else{
                    data.EmployeeNetSalary.Salary = String(data.EmployeeNetSalary.Salary).replace('.',',')
                }
            }
            debugger;
            

            let formData = await Additional.ToFormData(data)
            if(bool){
                this.sgkLoading = true
            }else{
                this.netLoading = true
            }
            this.loading = true
            EmployeeOperationsApi.Employee.CreateOrUpdate(formData).then(res=>{
                this.$result(res)
                this.sgkLoading = false
                this.netLoading = false
                if(res.data.Success){
                    this.getPersonal()
                }
            }).catch(err=>{
                this.sgkLoading = false
                this.netLoading = false
                this.$result(null,err)
            })
        },
        onMW(bool){
            if(bool){
                if(this.value.net.IsMinimumWage){
                    this.value.net.UCRET_NEVI = 'G'
                }
            }else{
                if(this.value.sgk.IsMinimumWage){
                    this.value.sgk.UCRET_NEVI = 'G'
                }
            }
        },
        getCurrencyUnits(){
            SystemDataApi.CurrencyUnit().then(res=>{
                this.currencies = res.data.Data
            })
        },
        getSalaryTypes(){
            SystemDataApi.SalaryType().then(res=>{
                this.types = Object.entries(res.data).map(([key,value])=>({
                    Id:key,
                    Name:value
                }))
            })
        }
    },
    computed:{
        gStatus(){
            return System.GStatus
        },
        netSalaryUnit:{
            get:function(){
                return this.currencies.find(b=>b.Id==this.value.net.CurrencyUnitId)
            },
            set:function(value){
                this.value.net.CurrencyUnitId = value?.Id || null
            }
        },
        sgkSalaryUnit:{
            get:function(){
                return this.currencies.find(b=>b.Id==this.value.sgk.CurrencyUnitId)
            },
            set:function(value){
                this.value.sgk.CurrencyUnitId = value?.Id || null
            }
        },
        netSalaryType:{
            get:function(){
                return this.types.find(b=>b.Id==this.value.net.UCRET_NEVI)
            },
            set:function(value){
                this.value.net.UCRET_NEVI = value?.Id || null
            }
        },
        sgkSalaryType:{
            get:function(){
                return this.types.find(b=>b.Id==this.value.sgk.UCRET_NEVI)
            },
            set:function(value){
                this.value.sgk.UCRET_NEVI = value?.Id || null
            }
        }
    }
}
</script>

<style>

</style>